module.exports = __webpack_public_path__ + "img/1F1F1-1F1F9.34e8514e.svg";